import { Product } from '../types/product'

const isProductLike = (value: unknown): value is Product => {
  if (!value || typeof value !== 'object') return false
  const product = value as Partial<Product>
  return typeof product.id === 'string' && typeof product.name === 'string'
}

export const extractProducts = (response: unknown): Product[] => {
  if (Array.isArray(response)) {
    return response.filter(isProductLike)
  }

  if (response && typeof response === 'object') {
    const data = response as { products?: unknown }
    if (Array.isArray(data.products)) {
      return data.products.filter(isProductLike)
    }
    if (isProductLike(response)) {
      return [response]
    }
  }

  return []
}

export const pickProductBySlug = (response: unknown, slug: string): Product | null => {
  const products = extractProducts(response)
  return products.find(product => product.slug === slug) || products[0] || null
}
